import { getDayOfWeek } from 'utils/deliveryDates';
import { isDateLocked } from 'utils/moveDelivery';

export const NO_MEALS_HINT = 'No meals will be delivered on this date. It will be treated as skipped after the order deadline.';

export const isResumedDate = (date, ordersByDeliveryDate) => (ordersByDeliveryDate[date] || []).some(o => o.quantity > 0);

// Skipping only stops the delivery: a subscription's share of the weekly pool stays on every date it skips.
export const coversDate = (sub, date) => sub.nextDeliveryDate === date || (sub.skippedDates || []).includes(date);

// A skipped plan date with unsaved meals counts as resumed, because saving those meals un-skips it.
export const withResumedDates = (subscriptions, ordersByDeliveryDate) => (subscriptions || []).map(sub => {
    const resumed = (sub.skippedDates || []).some(d =>
        getDayOfWeek(d).toLowerCase() === (sub.deliveryDay || '').toLowerCase() && isResumedDate(d, ordersByDeliveryDate));
    return resumed ? { ...sub, isSkipped: false } : sub;
});

// Saving skips an edited date left with no meals (backend skipEmptyPlanDates), but never a move's source date.
export const skipsOnSave = (date, ordersByDeliveryDate, pendingChanges) => {
    const entry = pendingChanges?.[date];
    const changes = entry?.isDirty ? entry.changes || [] : [];
    return changes.length > 0
        && !changes.some(c => c.type === 'MOVE_DELIVERY_DATE')
        && !isResumedDate(date, ordersByDeliveryDate)
        && !isDateLocked(date);
};
